const { createSlice } = require("@reduxjs/toolkit");

const defaultTheme = JSON.stringify({
  background: "#E6E6E6",
  text: "#333C4D",
  btnBg: "#ffffff",
  btnText: "#333C4D",
});

// Initial State
const initialState = {
  userData: {
    username: "",
    address: "",
    createdAt: "",
    email: "",
    phone: "",
    name: "",
    services: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    logo: "",
    selectedTemplate: "",
    tiktok: "",
    timing: "",
    youtube: "",
    x: "",
    updatedAt: "",
  },
  token: null,
  accountID: "",
  isLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.token = action.payload.token;
    },
    updateUserDetailsInReducer(state, action) {
      state.userData = { ...state.userData, ...action.payload };
    },
    updateLoader(state, action) {
      state.isLoading = action.payload;
    },
    logout(state) {
      localStorage.clear();
      state = { ...initialState };
      window.location.reload();
    },
  },
});

export const {
  login,
  updateUserDetailsInReducer,
  logout,
  completeFirstTimeSetup,
  updateLoader,
} = authSlice.actions;

export const getUserDetailsFromReducer = (state) => state?.auth?.userData;
export const getUserNameFromReducer = (state) =>
  state?.auth?.userData?.username;

export const getThemeColor = (state) =>
  state?.auth?.userData?.themeColor || defaultTheme;

export const getTokenFromReducer = (state) => state?.auth?.token;
export const getLoaderState = (state) => state?.auth?.isLoading;

export default authSlice.reducer;
